module.exports = __webpack_public_path__ + "8ad6b96476d6556711324f97a4787bc9.png";